import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from '../';

const FeatureBoxOneEInvoice = ({image, title, text})=> (
    <div style={{paddingInline: 10}} className=" col-lg-3">
        <div style={{padding: 40, minHeight: 300}} className="feature-style1">
            <div className="feature-icon"><img src={image} alt="featureicon"/></div>
            <h3 className="feature-title h5"><Link className="text-inherit" to={"#"}>{title}</Link></h3>
            <p className="">{text}</p>
        </div>
    </div>
);

export default FeatureBoxOneEInvoice;